<template>
    <div class="company-users">
        <AdminTable
            v-if="rows"
            :data="rows"
            header="Company Users"
            :headers="headers"
            @row-click="openUser"
        ></AdminTable>
        <div v-else class="p-20">Loading users…</div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import AdminTable from '@/components/AdminTable.vue';
import BO_API from '@/api/bo_api.js';
import { getUserType } from '@/utils/iam_utils';

const props = defineProps({
    account_id: { type: String, required: true },
    // id of the client root user whose page we are on, used for the breadcrumb back-link
    client_id: { type: String, default: null },
});

const router = useRouter();
const users = ref(null);

const headers = [
    { name: 'Username', key: 'username' },
    { name: 'Email', key: 'email' },
    { name: 'Role', key: 'role' },
    { name: '2FA', key: 'twoFA' },
    { name: 'Last login', key: 'lastLoginFormatted' },
];

const rows = computed(() => users.value && users.value.map(u => ({
    ...u,
    role: getUserType(u.type) || u.type || '-',
    twoFA: !u.two_fa_required ? 'Not required' : (u.two_factor_setup_completed ? 'Enrolled' : 'Pending setup'),
    lastLoginFormatted: u.lastLogin ? dayjs(u.lastLogin).format('YYYY-MM-DD HH:mm') : 'Never',
})));

async function load() {
    if (!props.account_id) return;
    const response = await BO_API.getCompanyUsers(props.account_id);
    users.value = response ? response.users : [];
}

function openUser(user) {
    router.push({
        name: 'bo_company_user',
        params: { user_id: user._id },
        query: props.client_id ? { client: props.client_id } : {},
    });
}

onMounted(load);
watch(() => props.account_id, load);
</script>

<style lang="scss" scoped>
.company-users {
    padding: 0 20px;
    :deep(tr) {
        cursor: pointer;
    }
}
</style>
